import { Suspense, useCallback, useState } from 'react'
import { RootErrorBoundary } from '@/components/error-boundaries/root-error-boundary'
import { LayoutSkeleton } from '@/components/layout/layout-skeleton'
import { MixpanelProvider } from '@/components/mixpanel/provider'
import { CompanySetter } from '@/components/root/company-setter'
import { ProtectedRoute as LoggedInRoute } from '@/components/root/protected-route'
import { RootContent } from '@/components/root/root'
import { SubscriptionCancelledToast } from '@/components/root/subscription-cancelled-toast'
import { SidebarProvider } from '@/components/sv/sidebar'
import { SIDEBAR_OPEN_KEY } from '@/config/local-storage'

const readSidebarOpen = (): boolean => {
  if (typeof window === 'undefined') {
    return true
  }
  const stored = window.localStorage.getItem(SIDEBAR_OPEN_KEY)
  if (stored === 'true') {
    return true
  }
  if (stored === 'false') {
    return false
  }
  return true
}

export const Root = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(readSidebarOpen)

  const handleSidebarOpenChange = useCallback((open: boolean) => {
    setIsSidebarOpen(open)
    window.localStorage.setItem(SIDEBAR_OPEN_KEY, String(open))
  }, [])

  return (
    <RootErrorBoundary>
      <LoggedInRoute>
        <SubscriptionCancelledToast />
        <SidebarProvider
          open={isSidebarOpen}
          onOpenChange={handleSidebarOpenChange}
        >
          <Suspense fallback={<LayoutSkeleton />}>
            <MixpanelProvider>
              <CompanySetter>
                <RootContent />
              </CompanySetter>
            </MixpanelProvider>
          </Suspense>
        </SidebarProvider>
      </LoggedInRoute>
    </RootErrorBoundary>
  )
}
